import React, {lazy} from "react";
import ReactDOM from "react-dom/client";
import {PersistGate} from "redux-persist/integration/react";
import "slick-carousel/slick/slick.css";
import {Provider} from "react-redux";
import {store, persistor} from "./redux/store";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={lazy} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
